export default "assets/images/texture_footer-c6c334fd.jpg";